<template>
    <div v-if="taskListTemplate && taskListTemplate.can_create_task_with_dependency">
        <select-input
            v-model="localValue"
            name="task_template_parent_id"
            :options="taskTemplateAvailableParents"
            placeholder="Välj beroende"
        />
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                required: true,
                type: String,
            },
            taskListTemplate: {
                type: Object,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                localValue: this.value,
            };
        },
        computed: {
            taskTemplateAvailableParents() {
                const tasks = {};

                this.taskListTemplate.tasks.forEach(task => {
                    tasks[task.id] = task.body;
                });

                return tasks;
            },
        },
        watch: {
            localValue(newValue) {
                this.$emit('input', newValue);
            },
        },
    };
</script>